export default __webpack_public_path__ + "static/media/colorpal-placeholder.587c51c9.jpg";